<template>
    <div class="tab-content">
      <!-- <el-tabs activeName="first">
        <el-tab-pane :label="$t('e_tab_progress_first')" name="first">
          <el-card> -->
            <div class="buttons" v-show="hide">
              <div>
                <el-button :disabled="!engagementPermission.addProgress" v-if="startBtn" @click="startTaskOpenModal" class="nav-tree__item" size="mini" type="primary" plain icon="fas fa-play">{{selectedRow.taskStatus == 3 ? ' ' + $t('e_tab_progress_first_btn_restart') : ' ' + $t('e_tab_progress_first_btn_start')}}</el-button>
                <el-button :disabled="!engagementPermission.addProgress" v-if="addBtn" @click="addProgressNote" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('e_tab_progress_first_btn_addProgressNote')}}</el-button>
                <el-button :disabled="!engagementPermission.holdProgress" v-if="holdBtn" @click="holdTaskOpen" class="nav-tree__item" size="mini" type="primary" plain icon="fas fa-pause"> {{$t('e_tab_progress_first_btn_hold')}}</el-button>
                <el-button :disabled="!engagementPermission.doneProgress || !(Math.round(engagementProgressData[0].progress) == 100)" v-if="doneBtn && engagementProgressData.length" @click="doneTaskOpen" class="nav-tree__item" size="mini" type="primary" plain icon="fas fa-check"> {{$t('e_tab_progress_first_btn_done')}}</el-button>
                <el-button :disabled="!engagementPermission.addProgress" v-if="reopenBtn" @click="restartTaskOpen" class="nav-tree__item" size="mini" type="primary" plain :icon="selectedRow.isReoccurring ? 'fas fa-play' : 'fas fa-sync'"> {{selectedRow.isReoccurring ?  $t('e_tab_progress_first_btn_start') : $t('e_tab_progress_first_btn_reopen')}}</el-button>
                <!-- <span style="margin-left: 10px; font-size: 14px;">Total Time: {{totalTimeH}}:{{totalTimeM}}</span> -->
                <!-- <el-button v-show="timerBtn" @click="timer" class="nav-tree__item" size="mini" type="primary" plain icon="fas fa-stopwatch"> Add Timer</el-button> -->
              </div>
              <div>
                <!-- <el-button v-show="timerBtn" @click="timer" class="nav-tree__item" size="mini" type="primary" plain icon="fas fa-stopwatch"> Add Timer</el-button> -->
                <el-tag type="info" size="medium" style="margin-left: 10px; margin-right: 0px; font-size: 14px;">{{$t('e_tab_progress_first_totalTime')}}: {{totalTimeH}}:{{totalTimeM}}</el-tag>
                <!-- <span style="margin-left: 10px; margin-right: 20px; font-size: 14px;">Total Time: {{totalTimeH}}:{{totalTimeM}}</span> -->
              </div>
            </div>
            <!--{{engagementProgressData}}-->
            <!--{{selectedRow}}-->
            <div class="my-window">
                <el-timeline v-show="timerList.length || engagementProgressData.length" style="padding-top: 20px;">
                    <!-- TIMER -->
                    <el-timeline-item
                        v-for="item in timerList"
                        :key="item.startDate"
                        :timestamp="item.companyUser.user.fullName"
                        placement="top">
                        <el-card class="card" style="background: #888; color: white;" :id="item.id">
                            <div class="card__header">
                                <div class="card__time">
                                    <div class="photo-group">
                                      <img v-if="item.companyUser.user.avatarUrl" :src="item.companyUser.user.avatarUrl">
                                    </div>
                                    <div style="margin-right: 10px;">
                                      <img v-show="item.status == 1" src="@/assets/img/live/live1.gif" width="12px;">
                                    </div>
                                    <div>
                                      {{$t('e_tab_progress_first_totalTime')}}: {{totalTime(item.startDate, item.time, item.totalTime, item.status)}}
                                    </div>
                                </div><br>
                                <div v-if="companyLayout.companyUserId == item.companyUserId" class="card__edit">
                                    <el-button v-if="item.status == 1" @click="pauseTimer(item.id, item.engagementId, item.engagementTaskId)" type="warning" plain size="mini" icon="fas fa-pause"></el-button>
                                    <el-button v-else @click="restartTimer(item.id, item.engagementId, item.engagementTaskId)" type="primary" plain size="mini" icon="fas fa-play"></el-button>
                                    <el-button @click="stopTimer(item.id, item.startDate, item.time, item.totalTime)" type="danger" plain size="mini" icon="fas fa-stop"></el-button>
                                </div>
                            </div>
                        </el-card>
                    </el-timeline-item>

                    <el-timeline-item v-for="(item, index) in engagementProgressData" :key="item.id" :timestamp="moment(item.createDate.toString(), 'X').format('LLLL') + ' ' + item.creatorCompanyUser.user.fullName" placement="top">
                        <div :id="item.id" :ref="item.id" >
                            <el-card class="card">
                                <div slot="header" class="card__header">
                                    <div class="photo-group">
                                        <img v-if="item.creatorCompanyUser.user.avatarUrl" :src="item.creatorCompanyUser.user.avatarUrl">
                                    </div>
                                    <div class="card__status">
                                        <el-tag size="small" type="success" style="margin-right: 10px;" v-html="item.actionType === 'In Progress' ?  $t('inProgress') : $t(item.actionType)"></el-tag>
                                    </div>
                                    <div v-if="item.actionType != 'Started'" class="card__progress">
                                        <el-progress :text-inside="true" :stroke-width="18" :percentage="Math.round(item.progress)"></el-progress>
                                    </div>
                                    <div v-if="item.actionType != 'Started'" class="card__time">
                                        {{$t('e_tab_progress_first_taskTime')}}: {{item.hoursSpent}}:{{item.minutesSpent}}
                                    </div>
                                    <div class="card__edit">
                                        <el-button v-show="item.actionType == 'In Progress'" type="warning" plain size="mini" @click="openModalAddRemarks(item.id)">Add Remarks</el-button>
                                        <el-button :disabled="!engagementPermission.editProgress" v-show="(index === 0  && item.actionType == 'In Progress') || item.editProgress" @click="editProgress(item.id)" type="primary" plain size="mini" icon="el-icon-edit"></el-button>
                                        <el-button :disabled="!engagementPermission.deleteProgress" v-show="index === 0  && item.actionType == 'In Progress'" @click="deleteProgress(item.id)" type="danger" plain size="mini" icon="el-icon-delete"></el-button>
                                    </div>
                                </div>
                                <div v-if="item.isReminderActive === 1" class="reminder-row">
                                    <font-awesome-icon icon="bell"/> {{$t('e_tab_progress_first_reminder')}}:
                                    <div class="reminder-date" v-if="item.reminderDate !== null">
                                        {{moment(item.reminderDate, 'X').format('lll')}}
                                    </div>
                                </div>
                                <div v-if="item.isBillable" slot="header" class="billing-details">
                                    <div class="billing-details__title">
                                        <img src="@/assets/img/info/dollar-sign.svg" width="20px;" style="margin-right: 5px;">
                                        <strong>Billing Details:</strong>
                                    </div>
                                    <div>
                                        <strong>Assignment:</strong> {{ item.assignment ? item.assignment.name : '' }}
                                    </div>
                                    <div>
                                        <strong>Activity:</strong> {{ item.activity ? item.activity.name : '' }}
                                    </div>
                                    <div>
                                        <strong>Short Note:</strong> {{ item.title }}
                                    </div>
                                </div>
                                <div class="text item">
                                    <div class="notifications">
                                        <div class="notifications_box">
                                            <div v-if="item.clientNotificated" class="notifications_clients">{{$t('e_tab_progress_first_notifyClients')}}: <i class="el-icon-success" style="color: green;"></i></div>
                                            <div v-if="item.vendorNotificated" class="notifications_vendors">{{$t('e_tab_progress_first_notifyVendors')}}: <i class="el-icon-success" style="color: green;"></i></div>
                                        </div>
                                    </div>
                                    <div>
                                        <p style="margin: 0;"><strong>{{$t('e_tab_progress_first_notes')}}:</strong></p>
                                        <p v-html="item.text" class="info-progress"></p>
                                    </div>
                                </div>

                                <!-- Remarks -->
                                <el-timeline-item
                                        v-for="item in item.remarks"
                                        :key="item.id"
                                        :timestamp="moment(item.createDate.toString(), 'X').format('LLLL') + ' ' + item.user.firstName + ' ' + item.user.lastName"
                                        placement="top">
                                    <div :id="item.id" :ref="item.id">
                                        <el-card class="card">

                                            <div slot="header" class="card__header">
                                                <div class="photo-group">
                                                    <img v-if="item.user.avatarUrl" :src="item.user.avatarUrl">
                                                </div>
                                                <div class="card__status">
                                                    <el-tag size="small" type="warning" style="margin-right: 10px;">Remarks</el-tag>
                                                </div>
                                            </div>

                                            <div class="text item">
                                                <div>
                                                    <p style="margin: 0;"><strong>{{$t('project_tab_progress_first_notes')}}:</strong></p>
                                                    <div class="info-progress">
                                                        <p v-html="item.text"></p>
                                                    </div>
                                                </div>
                                            </div>

                                        </el-card>
                                    </div>

                                </el-timeline-item>
                                <!-- Remarks -->
                            </el-card>
                        </div>
                    </el-timeline-item>
                </el-timeline>
            </div>
            <CreateEngagementTaskProgressModal :parentBill="parentBill" :assignmentList="assignmentList" :engagementPermission="engagementPermission" :allowNotification="allowNotification" @submit="getEngagements" ref="modal2" :selectedRow="selectedRow"/>
            <AddProgressNote ref="modal3"/>
            <ProgressEngagement :parentBill="parentBill" :assignmentList="assignmentList" ref="modal666" @submit="getEngagements" :activeProjectId="activeEngagementId" :stopTime="stopTime" :progress="progress"/>
            <!--{{selectedRowId}}-->
            <!--{{taskStatus}}-->
            <!--START TASK MODAL-->
            <sweet-modal blocking :title="title" ref="startTask" class="modal" v-on:close="closeModal">
                <!-- <h1 v-if="doneTask === 'start'" >Start Task</h1>
                <h1 v-else-if="doneTask === 'done'" >Done Task</h1>
                <h1 v-else-if="doneTask === 'hold'" >Hold Task</h1>
                <h1 v-else-if="doneTask === 'restart'" >Reopen Task</h1> -->
                <el-form :model="form" status-icon ref="form" label-position="top" label-width="0" class="demo-ruleForm">
                    <el-form-item>
                        <vue2-custom-editor
                          ref="editor"
                          v-model="form.text"/>
                        <!--<el-input-->
                        <!--type="textarea"-->
                        <!--:rows="2"-->
                        <!--placeholder="Please input"-->
                        <!--v-model="form.text">-->
                        <!--</el-input>-->
                    </el-form-item>

                    <div class="flex-twocolumn">
                      <el-form-item>
                          <el-switch :disabled="true" v-model="form.notifyEngagementTeam"></el-switch> {{$t('e_tab_progress_first_notifyEngagementTeam')}}
                      </el-form-item>
                      <el-form-item>
                          <el-switch v-model="form.notifyTaskTeam"></el-switch> {{$t('e_tab_progress_first_notifyTaskTeam')}}
                      </el-form-item>
                      <el-form-item>
                          <el-switch :disabled="allowNotification" v-model="form.notifyClients"></el-switch> {{$t('modal_notifyClients')}}
                      </el-form-item>
                      <el-form-item>
                          <el-switch :disabled="allowNotification" v-model="form.notifyVendors"></el-switch> {{$t('modal_notifyVendors')}}
                      </el-form-item>
                    </div>
                    <!--{{allowNotification}}-->
                    <el-form-item v-show="showProgressWhenRestart" :label="$t('e_tab_progress_first_progress')" prop="Progress" >
                            <el-slider
                                    v-model="form.progress"
                                    :max="100"
                                    :min="0"
                                    :step="5"
                                    show-stops>
                            </el-slider>
                    </el-form-item>
                    <el-form-item class="modal__btn">
                        <el-button @click="modalCancel('startTask')">{{$t('general_cancel')}}</el-button>
                        <el-button v-if="doneTask === 'start'" @click="startTask" type="primary">{{$t('general_submit')}}</el-button>
                        <el-button v-else-if="doneTask === 'done'" @click="doneTaskSubmit" type="primary">{{$t('general_submit')}}</el-button>
                        <el-button v-else-if="doneTask === 'hold'" @click="holdTaskSubmit" type="primary">{{$t('general_submit')}}</el-button>
                        <el-button v-else-if="doneTask === 'restart'" @click="restartTaskSubmit" type="primary">{{$t('general_submit')}}</el-button>                </el-form-item>
                </el-form>
            </sweet-modal>
            <!--{{selectedTaskForInfo}}-->

            <sweet-modal blocking title="Add remarks" ref="addRemark" v-on:close="resetForm('remark')">

                <el-form :model="remark" :rules="rules" status-icon ref="remark" class="demo-ruleForm">
                    <el-form-item prop="remarkText">
                        <el-input type="textarea" v-model="remark.remarkText"></el-input>
                    </el-form-item>

                    <el-form-item class="modal__btn">
                        <el-button @click="modalCancel('addRemark')">{{$t('general_cancel')}}</el-button>
                        <el-button @click="addRemarks('remark')" type="primary">{{$t('general_submit')}}</el-button>
                    </el-form-item>
                </el-form>

            </sweet-modal>

            <!-- [ Modal are you sure ] start -->
            <!-- <sweet-modal blocking ref="confirmation" title="Delete Progress">
                Are you sure you want to delete this progress item?
                <template slot="box-action">
                    <a class="button" @click="deleteProgressItem()">Ok</a> &nbsp;
                    <a class="button" @click="$refs.confirmation.close()">Cancel</a>
                </template>
            </sweet-modal> -->
            <!-- [ Modal are you sure ] end -->

            <!-- [ Modal form Edit Progress ] start -->
            <EditProgress :parentBill="parentBill" :assignmentList="assignmentList" @submit="getEngagements" ref="modal" :companyProgressItem="companyProgressItem" :prevEngagementTaskProgress="prevEngagementTaskProgress"/>
            <!-- [ Modal form Edit Progress ] end -->
          <!-- </el-card>
        </el-tab-pane>
      </el-tabs> -->
      <!-- <div v-if="selectedRow.type !== 'project'" class="book-mark-block pointer">
        <div>
          <div v-if="bookmarkList.progresses" @click="changeBookMark(bookmarkList.progresses, $route.query.companyId, selectedRow.engagementId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_act.svg"></div>
          <div v-else @click="changeBookMark(bookmarkList.progresses, $route.query.companyId, selectedRow.engagementId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>
        </div>
      </div> -->
    </div>
</template>

<script>
    let moment = require('moment')
    import axios from 'axios'
    import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
    import EditProgress from "@/components/Engagements/progress/EditProgress.vue";
    import CreateEngagementTaskProgressModal from '@/components/Engagements/CreateEngagementTaskProgressModal.vue';
    import AddProgressNote from '@/components/Engagements/progress/AddProgressNote.vue'
    import ProgressEngagement from '@/components/Engagements/progress/Progress.vue'
    import { VueEditor } from 'vue2-editor'
    import Vue2CustomEditor from "../vue-2-custom-editor"
    export default  {
        name: 'progress-tab',
        components: {
            CreateEngagementTaskProgressModal,
            SweetModal,
            Vue2CustomEditor,
            EditProgress,
            AddProgressNote,
            ProgressEngagement,
        },
        created() {
            this.$store.dispatch('getCompanyLayout')
        },
        mounted(){
          switch (this.selectedRow.taskStatus) {
            case -1:
              this.hide = false
              break;
            case 1:
              this.hide = true
              this.startBtn = true,
                this.addBtn = false,
                this.doneBtn = false,
                this.holdBtn = false,
                this.reopenBtn = false,
                this.timerBtn = false
              break;
            case 2:
              this.hide = true
              this.startBtn = false,
                this.addBtn = true,
                this.doneBtn = true,
                this.holdBtn = true,
                this.reopenBtn = false,
                this.timerBtn = true
              break;
            case 3:
              this.hide = true
              this.startBtn = true,
                this.addBtn = false,
                this.doneBtn = false,
                this.holdBtn = false,
                this.reopenBtn = false,
                this.timerBtn = false
              break;
            case 4:
              this.hide = true
              this.startBtn = false,
                this.addBtn = false,
                this.doneBtn = false,
                this.holdBtn = false,
                this.reopenBtn = true,
                this.timerBtn = false
              break;
            case 5:
              this.hide = true
              this.startBtn = false,
                this.addBtn = true,
                this.doneBtn = true,
                this.holdBtn = true,
                this.reopenBtn = false,
                this.timerBtn = true
              break;
            default:
            // alert( 'Я таких значений не знаю' );
          }
        },
        props:['selectedTaskForInfo',
            'selectedRowId',
            // 'progressData',
            // "isOnProgress",
            // 'bookmarkList',
            'selectedRow',
            'engagementPermission'],
        computed:{
            taskStatus(){
                return this.selectedRow.taskStatus
            },
            engagementProgressData(){
                return this.$store.state.engagementProgressData
            },
            timerList(){
                return this.$store.getters.getTimerListCas
            },
            companyLayout() {
                return this.$store.getters.getCompanyLayout
            },
            title: function () {
                return (this.doneTask === 'start' && this.selectedRow.taskStatus != 3) ? this.$i18n.t('general_startTask') :
                    (this.doneTask === 'start' && this.selectedRow.taskStatus == 3) ? this.$i18n.t('general_restartTask') :
                    (this.doneTask === 'done') ? this.$i18n.t('general_doneTask') :
                    (this.doneTask === 'hold') ? this.$i18n.t('general_holdTask') :
                    (this.doneTask === 'restart') ? this.$i18n.t('general_reopenTask') : ''
            }
        },
        data(){
            return{
                stopTime: '00:00',
                progress: 0,
                activeEngagementId: 0,

                allowNotification: false,
                companyProgressItem: null,
                prevEngagementTaskProgress: 0,
                activeStar: 'el-icon-star-on',
                notActiveStar: 'el-icon-star-off',
                parentBill: false,
                assignmentList: [],
                progressId: 0,
                totalTimeH: 0,
                totalTimeM: 0,
                moment:moment,
                hide: true,
                startBtn: false,
                addBtn: false,
                doneBtn: false,
                holdBtn: false,
                reopenBtn: false,
                timerBtn: false,
                showProgressWhenRestart: false,
                form:{
                    text: "",
                    notifyEngagementTeam: true,
                    notifyTaskTeam: true,
                    notifyClients: false,
                    notifyVendors: false
                },
                disabledBtn: true,
                doneTask: 'start',

                remark: {
                    remarkText: '',
                },
                rules: {
                    remarkText: [
                        { required: true, message: 'Please input remark', trigger: 'blur' }
                    ]
                }
            }
        },
        methods:{
          // Add Remarks
            openModalAddRemarks(progressId) {
                this.progressId = progressId
                this.$refs.addRemark.open()
            },
            addRemarks(formName) {
              this.$refs[formName].validate((valid) => {
                  if (valid) {
                      let loader = this.$loading.show();
                      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                      axios.post(`/api/v1/progress-remark/create`, {
                              progressId: this.progressId,
                              type: 'engagement',
                              text: this.remark.remarkText,
                          })
                          .then(response => {
                              this.$store.dispatch('getEngagementProgressesList', this.selectedRowId)
                              this.$refs.addRemark.close();
                              this.notification("Success", "Add Remarks", "success");
                              loader.hide()
                          })
                          .catch(error => {
                              console.log('An error occurred:', error);
                              loader.hide()
                          });
                  } else {
                      console.log('error submit!!');
                      return false;
                  }
              });
          },
          resetForm(formName) {
              this.$refs[formName].resetFields();
          },
          async selectActiveProgressNode(stateId){
            try {
              const childNode = await new Promise((resolve) => resolve(document.getElementById(stateId.toString())));
              console.log('childNode', childNode);
              if (childNode) {
                const parentContainer = await new Promise((resolve) => resolve(document.getElementById("pane-taskInfoTab").parentNode));
                console.log('parentContainer', parentContainer);
                // get distance between blocks
                const distance = await this.countDistance(parentContainer.getBoundingClientRect(), childNode.getBoundingClientRect(), childNode.offsetTop, parentContainer.scrollTop);
                // console.log('distance', distance);
                parentContainer.scroll({
                  top: distance,
                  behavior: 'smooth'
                });
                // set active class to block
                await new Promise((resolve) => resolve(childNode.classList.add('hovered-node')));
                setTimeout(() => {
                  childNode.classList.remove('hovered-node');
                  this.$store.dispatch('setStateId', null)
                }, 1000)
              }
            } catch (err){
              console.log(err)
            }
          },
          countDistance(parent, child, childOffsetTop, parentScrollTop){
            // console.log('childOffsetTop', childOffsetTop);
            // console.log('parent-top', parent);
            // console.log('child-top', child);
            return new Promise ((resolve) => {
              let distance = 0;
              if (parent.top < child.top){
                distance = (child.top +  parentScrollTop) - parent.top - childOffsetTop;
              } else if (parent.top > child.top) {
                distance = parentScrollTop - (parent.top - child.top + childOffsetTop)
              }
              resolve(distance || 0)
            })
          },
          modalCancel(ref) {
              this.$refs[ref].close();
          },
          // TIMER
          totalTime(startTime, time, total, status) {

              let s
              if (startTime === null) {
                  s = total
              } else {
                    s =  time - startTime + total
              }

              let sec = s % 60
              let min = Math.floor((s / 60) % 60)
              let hour = Math.floor(s / 3600)

              if (sec.toString().length < 2) {
                  sec = '0' + sec
              }
              if (min.toString().length < 2) {
                  min = '0' + min
              }
              if (hour.toString().length < 2) {
                  hour = '0' + hour
              }

              // this.time = hour + ':' + min + ':' + sec
              return hour + ':' + min
              //  + ':' + sec

          },
          // changeBookMark(state, companyid, engagementId, taskId){
          //   let data = this.bookmarkList
          //   data.progresses = !this.bookmarkList.progresses
          //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          //   axios.post(`/api/v1/bookmarks/setEngagementTask?companyId=${companyid}&engagementId=${engagementId}&engagementTaskId=${taskId}`, data)
          //     .then(response => {
          //       if (this.bookmarkList.progresses) {
          //         this.notification(this.$i18n.t('notification_title_success'), this.$t('notification_bookmarkAdded'), "success")
          //       } else {
          //         this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
          //       }
          //     })
          //     .catch(error => {
          //       console.log('An error occurred:', error);
          //     });
          // },
          timer() {
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios.post(`/api/v1/engagementTaskTimers/create?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRowId}`)
                  .then(response => {
                      console.log('---/engagementTaskTimers/create', response.data);
                      this.$store.dispatch('getTimerListCas', {engagementId: this.$route.query.engagementId, engagementTaskId: this.selectedRowId})
                      this.notification(this.$i18n.t('notification_title_success'), "Task start time", "success");
                      this.getEngagements()
                  })
                  .catch(error => {
                      console.log('An error occurred:', error);
                  });
          },
          pauseTimer(id, engagementId, engagementTaskId) {
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios.post(`/api/v1/engagementTaskTimers/pause?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRowId}&engagementTaskTimerId=${id}`)
                  .then(response => {
                      console.log('---/projectTaskTimers/pause', response.data);
                      this.$store.dispatch('getTimerListCas', {engagementId: engagementId, engagementTaskId: engagementTaskId})
                      this.notification(this.$i18n.t('notification_title_success'), "Timer pause", "success");
                  })
                  .catch(error => {
                      console.log('An error occurred:', error);
                  });
          },
          restartTimer(id, engagementId, engagementTaskId) {
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios.post(`/api/v1/engagementTaskTimers/restart?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRowId}&engagementTaskTimerId=${id}`)
                  .then(response => {
                      console.log('---/engagementTaskTimers/restart', response.data);
                      this.$store.dispatch('getTimerListCas', {engagementId: engagementId, engagementTaskId: engagementTaskId})
                      this.notification(this.$i18n.t('notification_title_success'), "Timer restart", "success");
                  })
                  .catch(error => {
                      console.log('An error occurred:', error);
                  });
          },
          stopTimer(id, startTime, time, total) {
            // let s
            //   if (startTime === null) {
            //       s = total
            //   } else {
            //        s =  time - startTime + total
            //   }

            //   let sec = s % 60
            //   let min = Math.floor((s / 60) % 60)
            //   let hour = Math.floor(s / 3600)

            //   if (sec.toString().length < 2) {
            //       sec = '0' + sec
            //   }
            //   if (min.toString().length < 2) {
            //       min = '0' + min
            //   }
            //   if (hour.toString().length < 2) {
            //       hour = '0' + hour
            //   }

            // this.time = hour + ':' + min + ':' + sec
            // return hour + ':' + min + ':' + sec

            // this.stopTime = hour + ':' + min
            // this.$refs.modal3.projectTaskTimerId = id;
            // this.$refs.modal3.projectTaskId = this.selectedRowId;
            // this.$refs.modal3.$refs['createProjectTaskProgress'].open();

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/engagementTaskTimers/preStop?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRowId}&engagementTaskTimerId=${id}`)
              .then(response => {
                  console.log('---/engagementTaskTimers/preStop', response.data);
                  let s = response.data.data.totalTime

                  let sec = s % 60
                  let min = Math.floor((s / 60) % 60)
                  let hour = Math.floor(s / 3600)

                  if (sec.toString().length < 2) {
                      sec = '0' + sec
                  }
                  if (min.toString().length < 2) {
                      min = '0' + min
                  }
                  if (hour.toString().length < 2) {
                      hour = '0' + hour
                  }

                  this.activeEngagementId = this.$route.query.engagementId

                  this.stopTime = hour + ':' + min
                  this.progress = Math.round(response.data.data.progress)

                  this.$refs.modal666.depTaskId = this.selectedRowId;
                  this.$refs.modal666.depTaskTimerId = id;
                  this.$refs.modal666.$refs['createProjectTaskProgress'].open();
              })
              .catch(error => {
                  console.log('An error occurred:', error);
              });
          },

          deleteProgress(progressId) {
            this.progressId = progressId
            // this.$refs.confirmation.open();

            this.$confirm(this.$t('engagement_progresstab_thisWillPermanentlyDeleteProgressItemContinue'), this.$t('general_warning'), {
              confirmButtonText: this.$t('general_ok'),
              cancelButtonText: this.$t('general_cancel'),
              type: 'info'
            }).then(() => {
              this.$message({
                type: 'success',
                message: this.$t('general_delete')
              });

              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios.post(`/api/v1/engagementTaskProgresses/delete?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRowId}&engagementTaskProgressId=${this.progressId}`)
                  .then(response => {
                      console.log('---', response.data);
                      this.$store.dispatch('getEngagementProgressesList', this.selectedRowId)
                      // this.notification(this.$i18n.t('notification_title_success'), "Delete Progress", "success")
                      this.getEngagements()
                      this.$refs.confirmation.close();
                  })
                  .catch(error => {
                      this.notification(this.$i18n.t('notification_title_warning'), error.response.data.message, "warning")
                      console.log('An error occurred:', error);
                  });
            }).catch(() => {
              this.$message({
                type: 'info',
                message: 'Delete canceled'
              });
            });
          },
          // ! Clear
          // deleteProgressItem() {
          //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          //   axios.post(`/api/v1/engagementTaskProgresses/delete?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRowId}&engagementTaskProgressId=${this.progressId}`)
          //       .then(response => {
          //           console.log('---', response.data);
          //           this.$store.dispatch('getEngagementProgressesList', this.selectedRowId)
          //           this.$refs.confirmation.close();
          //           this.notification(this.$i18n.t('notification_title_success'), "Delete Progress", "success")
          //           this.getEngagements()
          //       })
          //       .catch(error => {
          //           this.notification(this.$i18n.t('notification_title_warning'), error.response.data.message, "warning")
          //           console.log('An error occurred:', error);
          //       });
          // },
          editProgress(progressId) {
              this.progressId = progressId
              console.log('---', 'editProgress');
              this.$refs.modal.engagementTaskId = this.selectedRowId;
              this.$refs['modal'].$refs['editProgressForm'].open()

              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios.post(`/api/v1/engagementTaskProgresses/directories?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRowId}&engagementTaskProgressId=${this.progressId}&operation=update`)
                .then(response => {
                  if (response.data.allowExternalNotifications === 1){
                    this.allowNotification = false
                  }else{
                    this.allowNotification = true
                    this.form.notifyClients = false
                    this.form.notifyVendors = false
                  }
                  this.parentBill = response.data.parentBill !== 2 ? true : false
                  this.assignmentList = response.data.assignmentWithActivitiesList
                  this.prevEngagementTaskProgress = +response.data.prevEngagementTaskProgress.progress

                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios
                      .post(`/api/v1/engagementTaskProgresses/item?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRowId}&engagementTaskProgressId=${this.progressId}`)
                      .then(response => {
                        console.log('---/engagementTaskProgresses/item', response.data);
                        this.companyProgressItem = response.data.item
                        this.$nextTick(() => {
                          this.$refs.modal.setImagesState()
                        })
                      })
                      .catch(error => {
                        console.log('An error occurred:', error);
                        // this.notification(this.$i18n.t('notification_title_warning'), error.response.data.message, "warning");
                      });
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                });
          },
            addProgressNote(){
                this.$refs.modal2.engagementTaskId = this.selectedRowId;
                this.itemRequest()
                this.$refs.modal2.$refs['createEngagementTaskProgress'].open();
            },
            startTaskOpenModal(){
              this.doneTask = 'start'
              this.itemRequest()
              this.$refs.startTask.open();
            },
            startTask(){
                let data = {
                    text: this.form.text,
                    notifyEngagementTeam: this.form.notifyEngagementTeam,
                    notifyTaskTeam: this.form.notifyTaskTeam,
                    notifyClients: this.form.notifyClients,
                    notifyVendors: this.form.notifyVendors,
                }
                let loader = this.$loading.show();
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios.post(`/api/v1/engagementTasks/start?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRowId}`, data)
                    .then(response => {
                        console.log('---', response.data);
                        if (response.data.success){
                            console.log("SUCCESS")
                            this.notification(this.$i18n.t('notification_title_success'), this.$i18n.t('success_taskStarted'), "success");
                            loader.hide()
                            this.$store.dispatch('getEngagementProgressesList', this.selectedRowId)
                            if (this.$refs.editor.uploadedImagesArray.length) {
                              this.$store.dispatch('approveUploadedImages', {
                                fileUrlArr: this.$refs.editor.uploadedImagesArray,
                                entityId: response.data.id,
                                entityTypeId: 39 // eng task progress
                              })
                            }
                            // if (this.$refs.editor.removedImages.length) this.$store.dispatch('deleteRemovedImages', this.$refs.editor.removedImages)
                            this.$refs.startTask.close();
                            this.form.text = '';
                            this.form.notifyEngagementTeam = true;
                            this.form.notifyTaskTeam = true;
                            this.form.notifyClients = false;
                            this.form.notifyVendors = false;
                        }
                        this.getEngagements();
                        loader.hide()
                    })
                    .catch(error => {
                        this.notification(this.$i18n.t('notification_title_warning'), error.response.data.message, "warning")
                        console.log('An error occurred:', error);
                        loader.hide()
                    });
            },
            notification(title, message, type) {
                this.$notify({
                    title: title,
                    message: message,
                    type: type
                });

            },
            getEngagements(){
                this.$emit('submit', Number(this.$route.query.engagementId), false, this.selectedRowId)
            },
          itemRequest(){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/engagementTaskProgresses/directories?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRowId}&operation=create`)
              .then(response => {
                if (response.data.allowExternalNotifications === 1){
                  this.allowNotification = false
                }else{
                  this.allowNotification = true
                  this.form.notifyClients = false
                  this.form.notifyVendors = false
                }
                this.parentBill = response.data.parentBill !== 2 ? true : false
                this.assignmentList = response.data.assignmentWithActivitiesList
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          },
          doneTaskOpen(){
            if(this.selectedRow.timerCount){
              this.notification(this.$i18n.t('notification_title_warning'), "Stop Timer", "warning")
              return
            }
            this.doneTask = 'done'
            this.itemRequest()
            this.$refs.startTask.open();
          },
          doneTaskSubmit(){
            console.log('DONE TASK')
            let data = {
              text: this.form.text,
              notifyEngagementTeam: this.form.notifyEngagementTeam,
              notifyTaskTeam: this.form.notifyTaskTeam,
              notifyClients: this.form.notifyClients,
              notifyVendors: this.form.notifyVendors,
            }
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/engagementTasks/done?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRowId}`, data)
              .then(response => {
                console.log('---', response.data);
                if (response.data.success){
                  console.log("SUCCESS")
                  this.notification(this.$i18n.t('notification_title_success'), this.$i18n.t('success_taskDone'), "success");
                  loader.hide()
                  this.$store.dispatch('getEngagementProgressesList', this.selectedRowId)
                  if (this.$refs.editor.uploadedImagesArray.length) {
                    this.$store.dispatch('approveUploadedImages', {
                      fileUrlArr: this.$refs.editor.uploadedImagesArray,
                      entityId: response.data.id,
                      entityTypeId: 39 // eng task progress
                    })
                  }
                  this.$refs.startTask.close();
                  this.form.text = '';
                  this.form.notifyEngagementTeam = true;
                  this.form.notifyTaskTeam = true;
                  this.form.notifyClients = false;
                  this.form.notifyVendors = false;
                }
                this.getEngagements();
                loader.hide()
              })
              .catch(error => {
                this.notification(this.$i18n.t('notification_title_warning'), error.response.data.message, "warning")
                console.log('An error occurred:', error);
                loader.hide()
              });
          },
          holdTaskOpen(){
            if(this.selectedRow.timerCount){
              this.notification(this.$i18n.t('notification_title_warning'), "Stop Timer", "warning")
              return
            }
            this.doneTask = 'hold'
            this.itemRequest()
            this.$refs.startTask.open();
          },
          holdTaskSubmit(){
            console.log('HOLD TASK')
            let data = {
              text: this.form.text,
              notifyEngagementTeam: this.form.notifyEngagementTeam,
              notifyTaskTeam: this.form.notifyTaskTeam,
              notifyClients: this.form.notifyClients,
              notifyVendors: this.form.notifyVendors,
            }
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/engagementTasks/hold?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRowId}`, data)
              .then(response => {
                console.log('---', response.data);
                if (response.data.success){
                  console.log("SUCCESS")
                  this.notification(this.$i18n.t('notification_title_success'), this.$i18n.t('success_taskHold'), "success");
                  loader.hide()
                  this.$store.dispatch('getEngagementProgressesList', this.selectedRowId)
                  if (this.$refs.editor.uploadedImagesArray.length) {
                    this.$store.dispatch('approveUploadedImages', {
                      fileUrlArr: this.$refs.editor.uploadedImagesArray,
                      entityId: response.data.id,
                      entityTypeId: 39 // eng task progress
                    })
                  }
                  this.$refs.startTask.close();
                  this.form.text = '';
                  this.form.notifyEngagementTeam = true;
                  this.form.notifyTaskTeam = true;
                  this.form.notifyClients = false;
                  this.form.notifyVendors = false;
                }
                this.getEngagements();
                loader.hide()
              })
              .catch(error => {
                this.notification(this.$i18n.t('notification_title_warning'), error.response.data.message, "warning")
                console.log('An error occurred:', error);
                loader.hide()
              });
          },
          restartTaskOpen(){
            this.showProgressWhenRestart = true
            this.itemRequest()
            this.doneTask = 'restart'
            this.$refs.startTask.open();
          },
          restartTaskSubmit(){
            console.log('RESTART TASK')
            let data = {
              text: this.form.text,
              notifyEngagementTeam: this.form.notifyEngagementTeam,
              notifyTaskTeam: this.form.notifyTaskTeam,
              notifyClients: this.form.notifyClients,
              notifyVendors: this.form.notifyVendors,
              progress: this.form.progress
            }
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/engagementTasks/restart?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRowId}`, data)
              .then(response => {
                console.log('---', response.data);
                if (response.data.success){
                  console.log("SUCCESS")
                  this.notification(this.$i18n.t('notification_title_success'), this.$i18n.t('success_taskReopened'), "success");
                  loader.hide()
                  this.$store.dispatch('getEngagementProgressesList', this.selectedRowId)
                  if (this.$refs.editor.uploadedImagesArray.length) {
                    this.$store.dispatch('approveUploadedImages', {
                      fileUrlArr: this.$refs.editor.uploadedImagesArray,
                      entityId: response.data.id,
                      entityTypeId: 39 // eng task progress
                    })
                  }
                  this.$refs.startTask.close();
                  this.form.text = '';
                  this.form.notifyEngagementTeam = true;
                  this.form.notifyTaskTeam = true;
                  this.form.notifyClients = false;
                  this.form.notifyVendors = false;
                  this.form.progress = 0;
                }
                this.getEngagements();
                loader.hide()
              })
              .catch(error => {
                this.notification(this.$i18n.t('notification_title_warning'), error.response.data.message, "warning")
                console.log('An error occurred:', error);
                loader.hide()
              });
          },
          closeModal(){
            this.showProgressWhenRestart = false
            this.form.text = '';
            this.form.notifyEngagementTeam = true;
            this.form.notifyTaskTeam = true;
            this.form.notifyClients = false;
            this.form.notifyVendors = false;
            this.form.progress = 0;
          },
        },
        watch:{
          taskStatus(val){
            console.log("CHANGED", val)
            switch (val) {
              case -1:
                this.hide = false
                break;
              case 1:
                this.hide = true
                this.startBtn = true,
                  this.addBtn = false,
                  this.doneBtn = false,
                  this.holdBtn = false,
                  this.reopenBtn = false,
                  this.timerBtn = false
                break;
              case 2:
                this.hide = true
                this.startBtn = false,
                  this.addBtn = true,
                  this.doneBtn = true,
                  this.holdBtn = true,
                  this.reopenBtn = false,
                  this.timerBtn = true
                break;
              case 3:
                this.hide = true
                this.startBtn = true,
                  this.addBtn = false,
                  this.doneBtn = false,
                  this.holdBtn = false,
                  this.reopenBtn = false,
                  this.timerBtn = false
                break;
              case 4:
                this.hide = true
                this.startBtn = false,
                  this.addBtn = false,
                  this.doneBtn = false,
                  this.holdBtn = false,
                  this.reopenBtn = true,
                  this.timerBtn = false
                break;
              case 5:
                this.hide = true
                this.startBtn = false,
                  this.addBtn = true,
                  this.doneBtn = true,
                  this.holdBtn = true,
                  this.reopenBtn = false,
                  this.timerBtn = true
                break;
              default:
              // alert( 'Я таких значений не знаю' );
            }
          },
          engagementProgressData(){
            this.totalTimeH = 0
            this.totalTimeM = 0
            this.engagementProgressData.forEach(val => {
              if(val.reminderDate !== null){
                if (val.reminderDate.toString().length < 8) {
                  val.reminderDate = '0' + val.reminderDate.toString()
                } else {
                  val.reminderDate = val.reminderDate.toString()
                }
              }
              if(val.hoursSpent.toString().length < 2){
                val.hoursSpent = '0' + val.hoursSpent.toString()
              }
              if(val.minutesSpent.toString().length < 2){
                val.minutesSpent = '0' + val.minutesSpent.toString()
              }
              this.totalTimeH = this.totalTimeH + Number(val.hoursSpent)
              this.totalTimeM = this.totalTimeM + Number(val.minutesSpent)

              console.log('HOURS SPEND',val.hoursSpent)
              switch (val.actionType) {
                case 1:
                  val.actionType = "In Progress"
                  break;
                case 2:
                  val.actionType = "Started"
                  break;
                case 3:
                  val.actionType = "Reopened"
                  break;
                case 4:
                  val.actionType = "Done"
                  break;
                case 5:
                  val.actionType = "Hold"
                  break;
                case 6:
                  val.actionType = "Restarted"
                  break;
                default:
                // alert( 'Я таких значений не знаю' );
              }
              //
              // if(val.actionType === 2){
              //     console.log("PROBALY")
              //     val.actionType = "FACK OFFF"
              // }
            })

            this.totalTimeH = this.totalTimeH + ((this.totalTimeM - this.totalTimeM % 60) / 60)
            this.totalTimeM = this.totalTimeM % 60
            // this.totalTimeH = this.totalTimeH + ((this.totalTimeM - this.totalTimeM % 60) / 60)
            if(this.totalTimeH.toString().length < 2){
              this.totalTimeH = '0' + this.totalTimeH.toString()
            }
            if(this.totalTimeM.toString().length < 2){
              this.totalTimeM = '0' + this.totalTimeM.toString()
            }
          }
        },
    }
</script>

<style lang="less" scoped>
    .buttons{
      // padding-top: 35px;
      display: flex;
      justify-content: space-between;
      // margin-bottom:15px;
    }
    .startedtask{
        display:none;
    }
    .sweet-modal-overlay{
        z-index:1000;
    }
    .box-card{
        margin:20px 0;
    }
    .text {
        position: relative;
        font-size: 14px;
    }

    .item {
        margin-bottom: 18px;
        display:flex;
        & > div{
            width:100%;
            img{
                max-width:100% !important;
            }
        }
    }

    .notifications {
        position: absolute;
        top: 0; /* Положение от нижнего края */
        right: 0;
        &_box {
            display: flex;
            justify-content: flex-end;
        }
        &_clients{
            margin-right: 10px;
        }
        &_vendors{

        }
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    .clearfix:after {
        clear: both
    }
    .card {
        .photo-group{
          overflow:hidden;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          margin-right: 20px;
          background: url('~@/assets/img/user-default.jpg');
          background-size: cover;
          img{
            width:100%;
            height:100%;
          }
        }
        &__header {
            display: flex;
            flex-direction: row;
            align-items: center;
        }
        .reminder-row{
            color:red;
            margin-bottom: 20px;
            .reminder-date{
                color:grey;
            }
        }
        &__status {

        }
        &__progress {
            width: 150px;
            // flex: 1;
            margin-right: 10px;
        }
        &__edit {
            margin-left: auto;
        }
        &__time {
            display: flex;
            align-items: center;
        }
    }
    // [ Modal ] start
    .button{
        cursor: pointer;
    }
    // [ Modal ] end
    .flex-twocolumn{
        display:flex;
        .el-form-item__content{
            margin:0 12px;
            font-size:13px;
            &:first-child {
                margin-left: 0px;
            }
        }
    }

    /deep/ ul.el-timeline {
      padding-inline-start: 0px;
    }
    .hovered-node{
        -webkit-box-shadow: 0 0 26px 5px #409EFF;
        box-shadow: 0 0 10px 5px #409EFF;
    }
</style>
